import { IconButton, Checkbox, HStack, Box, Tooltip } from '@chakra-ui/react'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'

import useTableScroll from '@hook/shared/use-table-scroll'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridParametrizationIncrementItem: FC<{ [key: string]: any }> = ({
  data
}) => {
  const { actions, columns, query } = useTableScroll()

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left',
            isNumeric: row.isNumeric
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])
  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'default') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal s"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                  />
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <>
                      <Checkbox
                        key={`table-action-${index}`}
                        colorScheme="red"
                        isChecked={action.selecteds.includes(data['id-id'])}
                        borderColor="blackAlpha.400"
                        alignItems="center"
                        onChange={() => {
                          if (action.onChange) {
                            action.onChange(data)
                          }
                        }}
                      />
                    </>
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align, isNumeric }, key) => (
        <td key={`${id}-${key}`} align={align || 'left'}>
          {(() => {
            if (id === 'obersevation') {
              return (
                <>
                  {value.length > 60 ? (
                    <>
                      <Tooltip label={value} placement="right" fontSize="md">
                        {query.length > 0 ? (
                          <Highlighter
                            searchWords={String(query).split(' ')}
                            textToHighlight={String(value)}
                          />
                        ) : (
                          value.substring(0, 59) + '...'
                        )}
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      <div className="body__th-value">
                        <Box
                          justifyContent={isNumeric ? 'center' : null}
                          textAlign={isNumeric ? 'center' : null}
                        >
                          {query.length > 0 ? (
                            <Highlighter
                              searchWords={String(query).split(' ')}
                              textToHighlight={String(value)}
                            />
                          ) : (
                            value
                          )}
                        </Box>
                      </div>
                    </>
                  )}
                </>
              )
            } else {
              return (
                <div className="body__th-value">
                  <Box
                    justifyContent={isNumeric ? 'center' : null}
                    textAlign={isNumeric ? 'center' : null}
                  >
                    {query.length > 0 ? (
                      <Highlighter
                        searchWords={String(query).split(' ')}
                        textToHighlight={String(value)}
                      />
                    ) : (
                      value
                    )}
                  </Box>
                </div>
              )
            }
          })()}
        </td>
      ))}
    </tr>
  )
}

export default TableGridParametrizationIncrementItem
